import * as yup from "yup";

export type ForgotPasswordFormValues = {
  email: string;
};

export const forgotPasswordValidationSchema = yup.object({
  email: yup
    .string()
    .required("Вкажіть свою електронну адресу")
    .email("Не правильний формат електронної адреси"),
});
